<template>
  <div>

  <landing></landing>
  <presentation></presentation>
  <workSection></workSection>
  <contact></contact>
</div>
</template>

<script>
import landing from './Landing.vue'
import contact from './Contact.vue'
import presentation from './Presentation.vue'
import workSection from './WorkSection.vue'



export default {
  components: {
    landing, contact, presentation, workSection
  },
  data(){
    return{

    }
  },
  mounted(){

    //landing
    let revealTllanding= new TimelineMax()
    revealTllanding.delay(1.5);
    revealTllanding.from('.landingLogo', 1, {
      y: '-100%', opacity:0,
      ease: Expo.easeOut
    });
    revealTllanding.from('.landing h2', 1, {
      x: '-100%', opacity:0,
      ease: Expo.easeOut
    }, "-=0.5");
    revealTllanding.from('.landing h3', 1, {
      x: '100%', opacity:0,
      ease: Expo.easeOut
    }, "-=0.5");
    revealTllanding.from('.landing hr', 1, {
      opacity:'0',width:0,
      ease: Expo.easeOut
    }, "-=0.5");
    revealTllanding.from('#portraitBack', 1, {
      x: '10%', opacity:0,
      ease: Expo.easeOut
    }, "-=0.5");
    revealTllanding.from('#pattern', 1, {
      opacity:0,
      ease: Expo.easeOut
    }, "-=0.5");
    revealTllanding.from('#portrait', 1, {
      x: '-10%', opacity:0,
      ease: Expo.easeOut
    }, "-=0.5");


      //contact
    let revealTlcontact = new TimelineMax()
    revealTlcontact.from('.contact h1', 1, {
      y: '-100%', opacity:0,
      ease: Expo.easeOut
    });
    revealTlcontact.from('.social', 1, {
      x: '100%', opacity:0,
      ease: Expo.easeOut
    }, "-=1");
    revealTlcontact.from('form', 1, {
      y: '100%', opacity:0,
      ease: Expo.easeOut
    }, "-=1");

    // Declare Scene
    const contact = this.$scrollmagic.scene({
      // ID of element where animation starts
      triggerElement: '.contact',

      // {0,0.5,1} - animations starts from {top,center,end} of window
      triggerHook: 0.5

      // Duration of animation
      // duration: 300

    })
      // Declaration of animation and attaching to element
      .setTween( revealTlcontact)

        this.$scrollmagic.addScene(contact)

    //presentation
  let revealTlpresentation = new TimelineMax()
  revealTlpresentation.from('.presentationTexte', 1, {
    y: '100%', opacity:0,
    ease: Expo.easeOut
  });

  // Declare Scene
  const presentation = this.$scrollmagic.scene({
    // ID of element where animation starts
    triggerElement: '.presentation',

    // {0,0.5,1} - animations starts from {top,center,end} of window
    triggerHook: 0.5

    // Duration of animation
    // duration: 300

  })
    // Declaration of animation and attaching to element
    .setTween( revealTlpresentation)


  // Add Scene to controller
  this.$scrollmagic.addScene(presentation)

      //worksection
    let revealTlworksection = new TimelineMax()
    revealTlworksection.from('.workSection h1', 1, {
      y: '-100%', opacity:0,
      ease: Expo.easeOut
    });
    revealTlworksection.from('.workSection h3', 0.5, {
      x: '-100%',opacity:0,
      ease: Expo.easeOut
    }, "-=1");
    revealTlworksection.from('.workSectionIllustration', 1, {
      x: '20%',opacity:0,
      ease: Expo.easeOut
    }, "-=0.5");
    // Declare Scene
    const worksection = this.$scrollmagic.scene({
      // ID of element where animation starts
      triggerElement: '.workSection',

      // {0,0.5,1} - animations starts from {top,center,end} of window
      triggerHook: 0.2

      // Duration of animation
      // duration: 300

    })
      // Declaration of animation and attaching to element
      .setTween( revealTlworksection)


    // Add Scene to controller
    this.$scrollmagic.addScene(worksection)



  }
}
</script>


<style scoped>

</style>
